import { render } from "./BrandActionMenu.vue?vue&type=template&id=2bf532bc&scoped=true"
import script from "./BrandActionMenu.vue?vue&type=script&lang=js"
export * from "./BrandActionMenu.vue?vue&type=script&lang=js"

import "./BrandActionMenu.vue?vue&type=style&index=0&id=2bf532bc&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf532bc"]])

export default __exports__